export * from '@primeuix/themes/nora/treetable';
export { default } from '@primeuix/themes/nora/treetable';
